import { post } from '@/js/api/http-helper';

export async function getHtmlByUrl(fd) {
    const data = await post(`/get-html-by-url`, fd);
    return data.data;
}
